"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaitForTransactionReceiptTimeoutError = exports.TransactionReceiptNotFoundError = exports.TransactionNotFoundError = exports.TransactionExecutionError = exports.InvalidStorageKeySizeError = exports.InvalidSerializedTransactionError = exports.InvalidSerializedTransactionTypeError = exports.InvalidSerializableTransactionError = exports.InvalidLegacyVError = exports.FeeConflictError = exports.prettyPrint = void 0;
const formatEther_js_1 = require("../utils/unit/formatEther.js");
const formatGwei_js_1 = require("../utils/unit/formatGwei.js");
const base_js_1 = require("./base.js");
function prettyPrint(args) {
  const entries = Object.entries(args).map(_ref => {
    let [key, value] = _ref;
    if (value === undefined || value === false) return null;
    return [key, value];
  }).filter(Boolean);
  const maxLength = entries.reduce((acc, _ref2) => {
    let [key] = _ref2;
    return Math.max(acc, key.length);
  }, 0);
  return entries.map(_ref3 => {
    let [key, value] = _ref3;
    return "  ".concat("".concat(key, ":").padEnd(maxLength + 1), "  ").concat(value);
  }).join('\n');
}
exports.prettyPrint = prettyPrint;
class FeeConflictError extends base_js_1.BaseError {
  constructor() {
    super(['Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.', 'Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others.'].join('\n'));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'FeeConflictError'
    });
  }
}
exports.FeeConflictError = FeeConflictError;
class InvalidLegacyVError extends base_js_1.BaseError {
  constructor(_ref4) {
    let {
      v
    } = _ref4;
    super("Invalid `v` value \"".concat(v, "\". Expected 27 or 28."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidLegacyVError'
    });
  }
}
exports.InvalidLegacyVError = InvalidLegacyVError;
class InvalidSerializableTransactionError extends base_js_1.BaseError {
  constructor(_ref5) {
    let {
      transaction
    } = _ref5;
    super('Cannot infer a transaction type from provided transaction.', {
      metaMessages: ['Provided Transaction:', '{', prettyPrint(transaction), '}', '', 'To infer the type, either provide:', '- a `type` to the Transaction, or', '- an EIP-1559 Transaction with `maxFeePerGas`, or', '- an EIP-2930 Transaction with `gasPrice` & `accessList`, or', '- a Legacy Transaction with `gasPrice`']
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidSerializableTransactionError'
    });
  }
}
exports.InvalidSerializableTransactionError = InvalidSerializableTransactionError;
class InvalidSerializedTransactionTypeError extends base_js_1.BaseError {
  constructor(_ref6) {
    let {
      serializedType
    } = _ref6;
    super("Serialized transaction type \"".concat(serializedType, "\" is invalid."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidSerializedTransactionType'
    });
    Object.defineProperty(this, "serializedType", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.serializedType = serializedType;
  }
}
exports.InvalidSerializedTransactionTypeError = InvalidSerializedTransactionTypeError;
class InvalidSerializedTransactionError extends base_js_1.BaseError {
  constructor(_ref7) {
    let {
      attributes,
      serializedTransaction,
      type
    } = _ref7;
    const missing = Object.entries(attributes).map(_ref8 => {
      let [key, value] = _ref8;
      return typeof value === 'undefined' ? key : undefined;
    }).filter(Boolean);
    super("Invalid serialized transaction of type \"".concat(type, "\" was provided."), {
      metaMessages: ["Serialized Transaction: \"".concat(serializedTransaction, "\""), missing.length > 0 ? "Missing Attributes: ".concat(missing.join(', ')) : ''].filter(Boolean)
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidSerializedTransactionError'
    });
    Object.defineProperty(this, "serializedTransaction", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "type", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.serializedTransaction = serializedTransaction;
    this.type = type;
  }
}
exports.InvalidSerializedTransactionError = InvalidSerializedTransactionError;
class InvalidStorageKeySizeError extends base_js_1.BaseError {
  constructor(_ref9) {
    let {
      storageKey
    } = _ref9;
    super("Size for storage key \"".concat(storageKey, "\" is invalid. Expected 32 bytes. Got ").concat(Math.floor((storageKey.length - 2) / 2), " bytes."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidStorageKeySizeError'
    });
  }
}
exports.InvalidStorageKeySizeError = InvalidStorageKeySizeError;
class TransactionExecutionError extends base_js_1.BaseError {
  constructor(cause, _ref10) {
    var _chain$nativeCurrency;
    let {
      account,
      docsPath,
      chain,
      data,
      gas,
      gasPrice,
      maxFeePerGas,
      maxPriorityFeePerGas,
      nonce,
      to,
      value
    } = _ref10;
    const prettyArgs = prettyPrint({
      chain: chain && "".concat(chain === null || chain === void 0 ? void 0 : chain.name, " (id: ").concat(chain === null || chain === void 0 ? void 0 : chain.id, ")"),
      from: account === null || account === void 0 ? void 0 : account.address,
      to,
      value: typeof value !== 'undefined' && "".concat((0, formatEther_js_1.formatEther)(value), " ").concat((chain === null || chain === void 0 || (_chain$nativeCurrency = chain.nativeCurrency) === null || _chain$nativeCurrency === void 0 ? void 0 : _chain$nativeCurrency.symbol) || 'ETH'),
      data,
      gas,
      gasPrice: typeof gasPrice !== 'undefined' && "".concat((0, formatGwei_js_1.formatGwei)(gasPrice), " gwei"),
      maxFeePerGas: typeof maxFeePerGas !== 'undefined' && "".concat((0, formatGwei_js_1.formatGwei)(maxFeePerGas), " gwei"),
      maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' && "".concat((0, formatGwei_js_1.formatGwei)(maxPriorityFeePerGas), " gwei"),
      nonce
    });
    super(cause.shortMessage, {
      cause,
      docsPath,
      metaMessages: [...(cause.metaMessages ? [...cause.metaMessages, ' '] : []), 'Request Arguments:', prettyArgs].filter(Boolean)
    });
    Object.defineProperty(this, "cause", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'TransactionExecutionError'
    });
    this.cause = cause;
  }
}
exports.TransactionExecutionError = TransactionExecutionError;
class TransactionNotFoundError extends base_js_1.BaseError {
  constructor(_ref11) {
    let {
      blockHash,
      blockNumber,
      blockTag,
      hash,
      index
    } = _ref11;
    let identifier = 'Transaction';
    if (blockTag && index !== undefined) identifier = "Transaction at block time \"".concat(blockTag, "\" at index \"").concat(index, "\"");
    if (blockHash && index !== undefined) identifier = "Transaction at block hash \"".concat(blockHash, "\" at index \"").concat(index, "\"");
    if (blockNumber && index !== undefined) identifier = "Transaction at block number \"".concat(blockNumber, "\" at index \"").concat(index, "\"");
    if (hash) identifier = "Transaction with hash \"".concat(hash, "\"");
    super("".concat(identifier, " could not be found."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'TransactionNotFoundError'
    });
  }
}
exports.TransactionNotFoundError = TransactionNotFoundError;
class TransactionReceiptNotFoundError extends base_js_1.BaseError {
  constructor(_ref12) {
    let {
      hash
    } = _ref12;
    super("Transaction receipt with hash \"".concat(hash, "\" could not be found. The Transaction may not be processed on a block yet."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'TransactionReceiptNotFoundError'
    });
  }
}
exports.TransactionReceiptNotFoundError = TransactionReceiptNotFoundError;
class WaitForTransactionReceiptTimeoutError extends base_js_1.BaseError {
  constructor(_ref13) {
    let {
      hash
    } = _ref13;
    super("Timed out while waiting for transaction with hash \"".concat(hash, "\" to be confirmed."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'WaitForTransactionReceiptTimeoutError'
    });
  }
}
exports.WaitForTransactionReceiptTimeoutError = WaitForTransactionReceiptTimeoutError;
//# sourceMappingURL=transaction.js.map